import texasMapData from "../../texasMap";
import texasRegionsMapData from "../../texasRegionsMap";

export const texasChartOptions = {
    title: {
        text: '',
    },
    chart: {
        renderTo: 'container',
        width: 750,
        height: 615,
        backgroundColor: 'transparent',
        type: 'map',
        marginLeft: 100,
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        map: {
            states: {
                hover: {
                    color: '#A6C5E1',
                }
            }
        },
    },
    legend: {
        enabled: false,
    },
    series: [{
        type: 'map',
        joinBy: 'id',
        mapData: texasMapData,
        data: [],
        dataLabels: {
            enabled: true,
            color: 'white',
            x: 40,
            style: {
                fontSize: '50px',
                fontWeight: 'bold',
                stroke: 'transparent',
                textOutline: 0,
                textShadow: '1px 1px 3px #585858',
            },
        },
    }],
    tooltip: {
        shadow: false,
        style: {
            textShadow: 'none',
        },
        formatter: function() {
            return `${this.point.name.toUpperCase()}: ${this.point.value}`;
        },
    }
};

export const texasRegionsChartOptions = {
    title: {
        text: ''
    },
    chart: {
        width: 700,
        height: 590,
        backgroundColor: 'transparent',
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false,
    },
    series: [{
        type: 'map',
        joinBy: 'id',
        mapData: texasRegionsMapData,
        data: [{
            id: 'id0',
            name: 'DFW',
            y: 0,
            value: 0,
            color: '#FDE256',
        }, {
            id: 'id1',
            name: 'Houston',
            y: 1,
            value: 0,
            color: '#7D8BFC',
        }, {
            id: 'id2',
            name: 'Austin',
            y: 2,
            value: 0,
            color: '#55C636',
        }, {
            id: 'id3',
            name: 'San Antonio',
            y: 3,
            value: 0,
            color: '#F15C5E',
        }, {
            id: 'id4',
            name: 'East',
            y: 4,
            value: 0,
            color: '#F19093',
        }, {
            id: 'id5',
            name: 'West',
            y: 5,
            value: 0,
            color: '#81CDC8',
        }, {
            id: 'id6',
            name: 'Central',
            y: 6,
            value: 0,
            color: '#FDC132',
        }, {
            id: 'id7',
            name: 'Valley',
            y: 7,
            value: 0,
            color: '#B19CC9',
        }],
        dataLabels: {
            enabled: true,
            allowOverlap: true,
            useHTML: true,
            style: {
                fontSize: '15px',
                fontWeight: 'bold',
                stroke: 'transparent',
                textOutline: 0,
                color: 'black',
            },
        },
    }],
    tooltip: {
        useHTML: true,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        formatter: function() {
            return `<div class="chart-tooltip">${this.point.name}: ${this.point.value}</div>`;
        },
    }
};